export * from "@workspace/gamja-platform/components/TrialActivatedModal";
export { default } from "@workspace/gamja-platform/components/TrialActivatedModal";
